import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { PageHeadingComponent } from '@bookinglab/govbook-ui/layout';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiService } from '../../services/jrni/api.service';
import { AppConfig } from '../../app.config';
import { ACCESSIBILITY_STATEMENT_FALLBACK } from './accessibility-statement.content';

@Component({
	selector: 'app-accessibility-statement',
	standalone: true,
	imports: [CommonModule, TranslatePipe, PageHeadingComponent],
	templateUrl: './accessibility-statement.component.html',
	styleUrl: './accessibility-statement.component.scss',
})
export class AccessibilityStatementComponent implements OnInit {
	statement = '';

	constructor(
		private apiService: ApiService,
		private router: Router,
		private spinner: NgxSpinnerService
	) {}

	async ngOnInit(): Promise<void> {
		this.spinner.show();
		try {
			const config: any = await this.apiService.getConfig(
				AppConfig.settings.core.company_id
			);
			// Source of truth is the BookingLab app config (SUP-2540).
			// Fall back to the bundled default if the key is not yet present.
			this.statement =
				config?.accessibilityStatementPage?.pageContent ||
				ACCESSIBILITY_STATEMENT_FALLBACK;
		} catch {
			this.statement = ACCESSIBILITY_STATEMENT_FALLBACK;
		}
		this.spinner.hide();
	}

	routerGoBack(): void {
		// Return to the start of the booking journey (SUP-2540).
		this.router.navigate(['/start']);
	}
}
